@if (showTooltip) {
  <app-map-tooltip
    [screenPoint]="screenPoint"
    [tooltipContent]="tooltipContent"
    id="tooltip"
    style="position: relative"
    />
}

<app-esri-map
  (mapComponentLoaded)="onMapComponentLoaded($event)"
  (markerHover)="_onShowTooltip($event)"
  [allowMarkerClick]="true"
  class="project-map"
  id="projectMap"
  />
